/** Learner blocker when opening any panel is enough (expandAllItems: false). */
export const accordionLearnBlockerId = (accordionId: string) =>
  `accordion_learn_${accordionId}`;
